// web componentだと要素ごとに初期化処理が走るので、閲覧履歴では使用しない
document.addEventListener('DOMContentLoaded', () => {
  const viewedIds = JSON.parse(localStorage.getItem('ProductRecentlyViewed') || '[]');

  // 表示の初期化処理
  const initRecentlyViewed = async (elSections) => {
    let resultHtml = "";
    if (viewedIds && viewedIds.length) {
      const queryString = getSearchQueryString(viewedIds);
      resultHtml = await getResultHtml(queryString);
    }

    for (const elSection of elSections) {
      const elContainer = elSection.querySelector('.js-recently-viewed');
      if (!elContainer) continue;
  
      if (!viewedIds.length) {
        elSection.classList.add('is-empty');
        continue;
      }

      elContainer.innerHTML = resultHtml;
    }
  }
  
  // 検索パラメータを作成
  const getSearchQueryString = (viewedIds) => {
    return viewedIds.map((id) => {
      return 'id:' + id;
    }).join(' OR ');
  }
  
  // 検索結果ページのHTMLを取得
  const getResultHtml = async (queryString) => {
    const options = {
      credentials: 'same-origin',
      method: 'GET'
    }
    const response = await fetch(`/search?&type=product&q=${queryString}`, options);
    const content = await response.text();
    const resultHtml = getModifiedHtml(content);
  
    return resultHtml;
  }
  
  // 調整したHTMLを返す
  const getModifiedHtml = (content) => {
    const elTmp = document.createElement('div');
    elTmp.innerHTML = content;
    const elSearchResults = elTmp.querySelector('.js-search-results');
    const elProductItems = elSearchResults.querySelectorAll('.js-product-item');

    // localStorageに保存されてる順序にあわせた属性を付与
    for (const elItem of elProductItems) {
      const elInformation = elItem.querySelector('.js-product-information');
      if (elInformation) elInformation.remove();

      const productId = elItem.dataset.productId;
      for (let i = 0; i < viewedIds.length; i++) {
        const id = viewedIds[i];
        // 登録されてる順序のオーダーや表示調整用の属性を設定
        let orderType = "";
        if (i === 0) {
          orderType = "first";
        } else if (i === viewedIds.length - 1) {
          orderType = "last";
        }

        if (productId === String(id)) {
          elItem.style.order = i + 1
          elItem.setAttribute('data-order', i + 1);
          elItem.setAttribute('data-order-type', orderType);
          continue;
        }
      }
    }

    return elSearchResults.innerHTML;
  }

  // 表示処理 実行
  const elSections = document.querySelectorAll('.js-recently-viewed-section');
  if (elSections.length) {
    initRecentlyViewed(elSections);
  }


  // 商品ページでIDをlocalStorageに保存
  const saveCurrentProduct = (productId) => {
    const MAX_NUM = 5;
    const currentViewedIds = JSON.parse(localStorage.getItem('ProductRecentlyViewed') || '[]');

    const viewedIds = currentViewedIds.filter(id => id !== productId);
    viewedIds.unshift(productId);
  
    try {
      const newViewedIds = JSON.stringify(viewedIds.slice(0, MAX_NUM));
      localStorage.setItem('ProductRecentlyViewed', newViewedIds);
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
      console.log(error);
    }
  };

  // 保存処理 実行
  const elProductId = document.querySelector('.js-recently-viewed-product-id');
  if (elProductId) {
    const productId = elProductId.dataset.productId;
    saveCurrentProduct(productId);
  }
});